import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, FormControl, Select, MenuItem } from '@material-ui/core';
const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(1)
  }
}));

const SelectType = props => {
  const { selectValue, onSelectValueChange, selectOptions = [] } = props;
  const classes = useStyles();
  return (
    <Box>
      <FormControl className={classes.formControl}>
        <Select
          value={selectValue}
          onChange={e => onSelectValueChange(e)}
        >
          {selectOptions.map((obj, ind) => {
            const key = Object.keys(obj)[0];
            const value = obj[key];
            return (
              <MenuItem key={ind} value={key}>
                {key}
                {value !== 0 && ` (${value})`}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SelectType;
